import { Box, ITheme, Pagination, PaginationItem, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { setPage } from '../../store/actions/portfolioLibrary';
import { PortfolioLibraryItem } from '../../models/Portfolio';

export interface IPortfolioPaginationProps{
    page: number;
    portfolios: PortfolioLibraryItem[] | undefined;
}

const PortfolioPagination: React.FC<IPortfolioPaginationProps> = ({ page, portfolios}) => {
    const theme = useTheme() as ITheme;
    const dispatch = useAppDispatch();

    const onChangePage = (page: number) => {
        dispatch(setPage(page-1));
    }

    useEffect(() =>{
        if (portfolios && page >= portfoliosCount/3){
            dispatch(setPage(page-1));
        }
    }, [portfolios, page, dispatch]);

    if (portfolios === undefined){
        return <></>
    }
    const portfoliosCount = portfolios.length;
    return <Box margin={"20px"}>
        <Pagination page={page+1} count={Math.floor((portfoliosCount+2)/3)} color='primary' onChange={(props, value) => onChangePage(value)}
            hideNextButton hidePrevButton renderItem={(item) => (
                <PaginationItem {...item} sx={{ fontSize: "16px", fontWeight:"400" , "&.Mui-selected": { backgroundColor: item.selected ? theme.palette.common.white : undefined, boxShadow: theme.shadows[1]}}} />
                )}/>
    </Box>
}

export default PortfolioPagination;